module.exports = __webpack_public_path__ + "img/Spinner-1s-200px.86ec94ee.svg";